import { Service } from "../shared/Service";

export class PublicoAlvoService extends Service{

  constructor(){
    super('publicoAlvo');
  }

}